<script>
import StoryContent from "%/dynamic-component-editor/standard-pages/story-page/StoryContent.vue";

export default {
  name: "StoryBody",
  extends: StoryContent,
  elementPanelSettings: {
    displayName: "Story Body",
    tags: ["story", "body", "content", "segments", "article"],
  },
};
</script>
